import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { AlertService } from '../../services/alert.service';
import { GenericAlertComponent } from '../generic-alert/generic-alert.component';

@Component({
  selector: 'app-alert-container',
  standalone: true,
  imports: [CommonModule, GenericAlertComponent],
  template: `
    <app-generic-alert
      *ngIf="currentAlert"
      [alertId]="currentAlert.id"
      [type]="currentAlert.type"
      [message]="currentAlert.message"
      [duration]="currentAlert.duration"
      (ngOnDestroy)="onAlertDestroy()"
    ></app-generic-alert>
  `
})
export class AlertContainerComponent implements OnDestroy {
  currentAlert: any = null;
  private readonly subscription: Subscription;

  constructor(private readonly alertService: AlertService) {
    this.subscription = this.alertService.alert$.subscribe(alert => {
      this.currentAlert = alert;
    });
  }
  onAlertDestroy() {
    this.currentAlert = null;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
} 